export default __webpack_public_path__ + "static/media/gm-png-girl.1a2eb9b9.webp";